import React, { useState } from "react";
import { Col } from "reactstrap";
import { GenaiUrl, imageURl } from "../../libs/env";
import { QuestionHeading } from "../../components/question/question_heading";
import { AudioPlayer } from "../../components/listening_exercise/audio_player";
import QuestionDescription from "../../components/question/QuestionDescrption";
import { handleHeaderInput } from "../../components/edit_quiz_helper/EditQuizHelper";
import ContentImageModel from "../../components/modals/ContentImageModel";
export const QuizContent = ({
  data,
  studentid,
  studentAssessmentId,
  isReview,
  datatype,
  visualizerToggle,
  onUpdate,
  instrItalic,
  setContentedit,
  Contentedit,
  pathname
}) => {
  const [isBlinking, setIsBlinking] = useState(false);
  const [expandData, setExpandData] = useState(false);
  const [ImageModal, setImageModal] = useState(false);
  const ImageToggle = () => setImageModal(!ImageModal);
  const focusBlink = (e) => {
    setIsBlinking(false);
  }
  const blurBlink = (e) => {
    if(Contentedit)
    {
      setIsBlinking(true);
    }
  }
  setTimeout(function () {
    if (isReview) {
      setExpandData(true);
    }
  }, 500);

  return (
    <Col>
      <div class="d-flex flex-column d-none">
        <img
          src={`${imageURl}/speech_img.png`}
          className="my-4"
          alt="Speech question content"
        />
        {/* <div style={{position: "relative", paddingBottom: "56.25%", height: "0"}}>
        <iframe src="https://www.youtube.com/embed/LQQE2hWrl98" frameborder="0"  style={{ position: "absolute", top: "0", left: "0",  width: "100%", height: "100%"}}>
        </iframe>
      </div> */}
        <p className="quiz-bottom-border"></p>
      </div>
      <div
        className={
          pathname?.includes(GenaiUrl)
            ? "d-flex flex-column quiz-bottom-border mb-2"
            : "d-flex flex-column"
        }
      >
        <QuestionHeading
          data={data}
          datatype={datatype}
          visualizerToggle={visualizerToggle}
          setContentedit={setContentedit}
          Contentedit={Contentedit}
          onUpdate={onUpdate}
          focusblink={focusBlink}
          blurblink={blurBlink}
          isBlinking={isBlinking}
          setIsBlinking={setIsBlinking}
        />
        {data.audio ? (
          <div>
            <div key={data.id}>
              {" "}
              <AudioPlayer
                data={data}
                studentid={studentid}
                studentAssessmentId={studentAssessmentId}
              />{" "}
            </div>
            <p className="quiz-bottom-border"></p>
          </div>
        ) : null}
        {data.html_content && (
          <QuestionDescription
            description={
              <div
                className={`${instrItalic}`}
                onFocus={focusBlink}
                onBlur={blurBlink}
                spellcheck="false"
                data-gramm="false"
                contentEditable={Contentedit}
                onInput={handleHeaderInput({
                  type: "htmlcontent",
                  quizdata: data,
                })}
                dangerouslySetInnerHTML={{
                  __html: `${data.html_content?.replace(/\[\[.*?\]\]\.\s*/g, '').replace(/\[\[.*?\]\]\s*/g, '')}`,

                }}
              />
            }
            isReview={expandData}
            showBtn={true}
            instrItalic={instrItalic}
            data={data}
            ImageToggle={ImageToggle}
          />
        )}
      </div>
      <ContentImageModel
          data={data}
          isOpen={ImageModal}
          toggle={ImageToggle}
      />
    </Col>
  );
};
